import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d1fd99d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_progress" }
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-circle-fill text-primary small" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary rounded-0 px-5" }, " Partner ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["card shadow-sm border-0 rounded-2 my-2", [_ctx.card.customCard]])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.body.title)
            ? (_openBlock(), _createElementBlock("h4", {
                key: 0,
                class: _normalizeClass(["mb-2", [_ctx.card.customTitle]])
              }, _toDisplayString(_ctx.body.title), 3))
            : _createCommentVNode("", true),
          (_ctx.body.body)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(["mb-2", [_ctx.card.customBody]])
              }, _toDisplayString(_ctx.body.body), 3))
            : _createCommentVNode("", true),
          (_ctx.body.stage !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass(["text-primary mb-2", [_ctx.card.customFooter]])
                }, [
                  _createElementVNode("small", {
                    class: _normalizeClass(["h-100 d-flex justify-content-between my-4", [_ctx.card.customStage]])
                  }, [
                    _createElementVNode("strong", null, "Stage " + _toDisplayString(_ctx.body?.level || "1") + ": " + _toDisplayString(_ctx.body.stage), 1),
                    _createElementVNode("strong", null, [
                      _hoisted_4,
                      _createTextVNode(" " + _toDisplayString(_ctx.body.status), 1)
                    ])
                  ], 2),
                  _createVNode(_component_router_link, { to: _ctx.buttonRoute }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["to"])
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}